<ng-container *transloco="let t;">
    <h1 class="mbm">Einstellungen</h1>

    <div class="grid col5 mbm">
        <ng-container *ngFor="let childItem of childRoutes">

            <button
                *ngIf="(childItem.data.permission | permission) && isEnabled(childItem, tenantSettings$ | async)"
                kendoButton
                size="medium"
                rounded="medium"
                [routerLink]="[childItem.path]"
                routerLinkActive="active"
            >{{ t(childItem.data.title) }}
            </button>
        </ng-container>
    </div>

    <router-outlet></router-outlet>
    
</ng-container>
